import createInflateDeflateStore from './createInflateDeflateStore';

/**
 * Inflate / Deflate sculpt brush state for the **Rectification** step.
 *
 * One instance per step that exposes the brush — see
 * `createInflateDeflateStore` for why sharing a single store between steps
 * would make an apply on one read as applied on the other.
 */
const useInflateDeflateStore = createInflateDeflateStore({
  name: 'rectification-inflate-deflate-store',
});

export default useInflateDeflateStore;
